import styled from "styled-components";
import Card from "@mui/material/Card";

export const Container = styled.div`
    margin-left: 10px;
`;

export const FormContainer = styled(Card)`
    padding: 25px;
    display: flex;
    flex-wrap: wrap;
    direction: column;
    margin: 5px;
    gap: 15px;
    justify-items: space-between;
`;

export const ButtonContainer = styled.div`
    display: flex;
    justify-content: flex-end;
    padding: 20px;
    margin-top: 20px;
    gap: 8px;
    
    button {
        min-width: 150px;
    }
`;
